import styled from '@emotion/styled'
import { css } from '@emotion/react'
import cn from 'classnames'
import { isEmpty } from 'util/objects'
import { Icon, Tooltip, Flex } from 'shared/ui'

import { getDisplayLabel } from 'util/recipientLabel'

const Recipient = styled(Flex)`
  border: 1px solid ${props => props.theme.color.monochrome.medium};
  border-radius: 10px;
  padding-left: ${props => props.theme.spacing['6']};
  padding-right: ${props => props.theme.spacing['6']};
  margin-bottom: ${props => props.theme.spacing['3']};
  width: 100%;
`

const Truncated = styled('div')`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const iconStyle = () => theme => css`
  margin-left: ${theme.spacing['3']};
`

export default function RemovableRecipient({
  className,
  allUsers,
  user,
  onClick,
  children,
}) {
  if (!user || isEmpty(user)) return null

  return (
    <Tooltip
      tooltip={user.email}
      position={'top'}
      css={css`
        max-width: 90%;
        margin-right: 4px;
      `}
    >
      <Recipient className={cn('grui items-baseline', className)}>
        <Truncated>{getDisplayLabel(user, allUsers)}</Truncated>
        <Icon
          name="close"
          size="xxsmall"
          onClick={onClick}
          css={iconStyle}
          color="color.monochrome.dark"
          hoverColor="blue"
        />
      </Recipient>
      {children}
    </Tooltip>
  )
}
